import { render, staticRenderFns } from "./EzSpecialTierItem.vue?vue&type=template&id=7484396e&scoped=true&"
import script from "./EzSpecialTierItem.vue?vue&type=script&lang=js&"
export * from "./EzSpecialTierItem.vue?vue&type=script&lang=js&"
import style0 from "./EzSpecialTierItem.vue?vue&type=style&index=0&id=7484396e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7484396e",
  null
  
)

export default component.exports